// import React, { useCallback, useEffect, useState } from "react";
// import {
//   getBeginnerSubscriptionPlans,
//   createBeginnerSubscriptionPlan,
//   updateBeginnerSubscriptionPlan,
//   deleteBeginnerSubscriptionPlan,
// } from "../api/beginnerAdminClient";

// const CLASS_OPTIONS = Array.from({ length: 8 }, (_, index) => index + 5);

// const rows = (response) => {
//   const data = response?.data;
//   if (Array.isArray(data)) return data;
//   if (Array.isArray(data?.results)) return data.results;
//   if (Array.isArray(data?.data)) return data.data;
//   return [];
// };

// const errorMessage = (error) => {
//   const data = error?.response?.data;
//   if (typeof data === "string") return data;
//   if (data?.detail) return data.detail;
//   if (data && typeof data === "object") {
//     return Object.entries(data)
//       .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(" ") : value}`)
//       .join(" ");
//   }
//   return error?.message || "Request failed.";
// };

// export default function BeginnerSubscriptionPlanManager() {
//   const [plans, setPlans] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [editing, setEditing] = useState(null);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");

//   const loadPlans = useCallback(async () => {
//     setLoading(true);
//     setError("");
//     try {
//       setPlans(rows(await getBeginnerSubscriptionPlans()));
//     } catch (e) {
//       setError(errorMessage(e));
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadPlans();
//   }, [loadPlans]);

//   const savePlan = async (event) => {
//     event.preventDefault();
//     const formElement = event.currentTarget;
//     const form = new FormData(formElement);
//     const classLevelValue = form.get("class_level");
//     const classLevel = classLevelValue === "" ? null : Number(classLevelValue);

//     const payload = {
//       name: String(form.get("name") || "").trim(),
//       price: Number(form.get("price")),
//       duration_days: Number(form.get("duration_days")),
//       practice_set_limit: Number(form.get("practice_set_limit")),
//       main_exam_attempt_limit: Number(form.get("main_exam_attempt_limit")),
//       class_level: classLevel,
//       // Backend currently requires each subscription plan to target exactly one class.
//       minimum_class: classLevel,
//       maximum_class: classLevel,
//       is_active: form.get("is_active") === "on",
//     };

//     if (!payload.name) {
//       setError("Enter a plan name.");
//       return;
//     }

//     if (
//       !Number.isFinite(payload.price) ||
//       payload.price < 0 ||
//       !Number.isFinite(payload.duration_days) ||
//       payload.duration_days < 1 ||
//       !Number.isInteger(payload.practice_set_limit) ||
//       payload.practice_set_limit < 0 ||
//       !Number.isInteger(payload.main_exam_attempt_limit) ||
//       payload.main_exam_attempt_limit < 0
//     ) {
//       setError("Check the price, duration, practice-set limit, and main-exam attempt limit.");
//       return;
//     }

//     if (payload.class_level == null || !CLASS_OPTIONS.includes(payload.class_level)) {
//       setError("Choose a class between Class 5 and Class 12.");
//       return;
//     }

//     setSaving(true);
//     setError("");
//     setMessage("");

//     try {
//       if (editing?.id) {
//         await updateBeginnerSubscriptionPlan(editing.id, payload);
//         setMessage("Subscription plan updated.");
//       } else {
//         await createBeginnerSubscriptionPlan(payload);
//         setMessage("Subscription plan created.");
//       }
//       setEditing(null);
//       formElement.reset();
//       await loadPlans();
//     } catch (e) {
//       setError(errorMessage(e));
//     } finally {
//       setSaving(false);
//     }
//   };

//   const removePlan = async (plan) => {
//     const action = plan.is_active ? "deactivate" : "delete";
//     if (!window.confirm(`Are you sure you want to ${action} "${plan.name}"?`)) return;

//     setSaving(true);
//     setError("");
//     setMessage("");

//     try {
//       await deleteBeginnerSubscriptionPlan(plan.id);
//       setMessage(
//         plan.is_active
//           ? "Plan deactivated (it may be retained because it has payments/subscriptions)."
//           : "Plan deleted or deactivated."
//       );
//       await loadPlans();
//     } catch (e) {
//       setError(errorMessage(e));
//     } finally {
//       setSaving(false);
//     }
//   };

//   const classSelect = (label, name, value) => (
//     <label key={name}>
//       {label}
//       <select name={name} defaultValue={value ?? ""} required>
//         <option value="">Choose class</option>
//         {CLASS_OPTIONS.map((classNumber) => (
//           <option key={classNumber} value={classNumber}>
//             Class {classNumber}
//           </option>
//         ))}
//       </select>
//     </label>
//   );

//   return (
//     <div className="beginner-admin-columns">
//       <section className="beginner-admin-panel">
//         <h2>{editing ? "Edit subscription plan" : "Create subscription plan"}</h2>

//         <form
//           className="beginner-admin-form"
//           onSubmit={savePlan}
//           key={editing?.id || "new-plan"}
//         >
//           <label>
//             Plan name
//             <input
//               name="name"
//               required
//               maxLength="120"
//               defaultValue={editing?.name || ""}
//               placeholder="e.g. Beginner Monthly"
//             />
//           </label>

//           <div className="beginner-admin-form-grid">
//             <label>
//               Price (₹)
//               <input
//                 name="price"
//                 type="number"
//                 min="0"
//                 step="0.01"
//                 required
//                 defaultValue={editing?.price ?? ""}
//               />
//             </label>

//             <label>
//               Duration (days)
//               <input
//                 name="duration_days"
//                 type="number"
//                 min="1"
//                 max="3650"
//                 required
//                 defaultValue={editing?.duration_days ?? 30}
//               />
//             </label>

//             <label>
//               Practice-set limit
//               <input
//                 name="practice_set_limit"
//                 type="number"
//                 min="0"
//                 max="100000"
//                 step="1"
//                 required
//                 defaultValue={editing?.practice_set_limit ?? 10}
//               />
//             </label>

//             <label>
//               Main-exam attempt limit
//               <input
//                 name="main_exam_attempt_limit"
//                 type="number"
//                 min="0"
//                 max="100000"
//                 step="1"
//                 required
//                 defaultValue={editing?.main_exam_attempt_limit ?? 2}
//               />
//             </label>

//             {classSelect(
//               "Subscription class",
//               "class_level",
//               editing?.class_level ?? editing?.minimum_class ?? ""
//             )}
//           </div>

//           <p className="beginner-admin-note">
//             Each subscription plan is assigned to one class only. Students in
//             other classes will not be eligible for this plan.
//           </p>

//           <label className="beginner-admin-check">
//             <input
//               name="is_active"
//               type="checkbox"
//               defaultChecked={editing ? editing.is_active !== false : true}
//             />
//             Active and available to students
//           </label>

//           <div className="beginner-admin-actions">
//             <button disabled={saving}>
//               {saving ? "Saving…" : editing ? "Save changes" : "Create plan"}
//             </button>
//             {editing && (
//               <button
//                 type="button"
//                 className="secondary"
//                 onClick={() => {
//                   setEditing(null);
//                   setError("");
//                   setMessage("");
//                 }}
//               >
//                 Cancel
//               </button>
//             )}
//           </div>
//         </form>
//       </section>

//       <section className="beginner-admin-panel">
//         <div className="beginner-admin-panel-title">
//           <h2>Subscription plans ({plans.length})</h2>
//           <button type="button" disabled={loading || saving} onClick={loadPlans}>
//             Refresh
//           </button>
//         </div>

//         {error && (
//           <div className="beginner-admin-alert error" role="alert">
//             {error}
//           </div>
//         )}

//         {message && (
//           <div className="beginner-admin-alert success" role="status">
//             {message}
//           </div>
//         )}

//         {loading ? (
//           <p className="beginner-admin-loading">Loading subscription plans…</p>
//         ) : plans.length === 0 ? (
//           <p className="beginner-admin-empty">
//             No subscription plans yet. Create your first plan using the form.
//           </p>
//         ) : (
//           <div className="beginner-admin-table-wrap">
//             <table>
//               <thead>
//                 <tr>
//                   <th>Plan</th>
//                   <th>Price</th>
//                   <th>Duration</th>
//                   <th>Practice limit</th>
//                   <th>Main exam attempts</th>
//                   <th>Eligible classes</th>
//                   <th>Status</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {plans.map((plan) => (
//                   <tr key={plan.id}>
//                     <td>{plan.name}</td>
//                     <td>₹{Number(plan.price ?? 0).toFixed(2)}</td>
//                     <td>{plan.duration_days} days</td>
//                     <td>{plan.practice_set_limit ?? 10}</td>
//                     <td>{plan.main_exam_attempt_limit ?? 2}</td>
//                     <td>
//                       {plan.class_level != null
//                         ? `Class ${plan.class_level}`
//                         : plan.minimum_class != null
//                           ? `Class ${plan.minimum_class}`
//                           : "Not assigned"}
//                     </td>
//                     <td>
//                       <span
//                         className={`beginner-admin-status ${
//                           plan.is_active ? "on" : "off"
//                         }`}
//                       >
//                         {plan.is_active ? "Active" : "Inactive"}
//                       </span>
//                     </td>
//                     <td className="beginner-admin-row-actions">
//                       <button
//                         type="button"
//                         disabled={saving}
//                         onClick={() => {
//                           setEditing(plan);
//                           setError("");
//                           setMessage("");
//                         }}
//                       >
//                         Edit
//                       </button>
//                       <button
//                         type="button"
//                         className="danger"
//                         disabled={saving}
//                         onClick={() => removePlan(plan)}
//                       >
//                         {plan.is_active ? "Deactivate / Delete" : "Delete"}
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </section>
//     </div>
//   );
// }
import React, { useCallback, useEffect, useState } from "react";
import {
  getBeginnerSubscriptionPlans,
  createBeginnerSubscriptionPlan,
  updateBeginnerSubscriptionPlan,
  deleteBeginnerSubscriptionPlan,
} from "../api/beginnerAdminClient";

const CLASS_OPTIONS = Array.from({ length: 8 }, (_, index) => index + 5);

const rows = (response) => {
  const data = response?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

const errorMessage = (error) => {
  const data = error?.response?.data;
  if (typeof data === "string") return data;
  if (data?.detail) return data.detail;
  if (data && typeof data === "object") {
    return Object.entries(data)
      .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(" ") : value}`)
      .join(" ");
  }
  return error?.message || "Request failed.";
};

export default function BeginnerSubscriptionPlanManager() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const loadPlans = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setPlans(rows(await getBeginnerSubscriptionPlans()));
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadPlans();
  }, [loadPlans]);

  const savePlan = async (event) => {
    event.preventDefault();
    const formElement = event.currentTarget;
    const form = new FormData(formElement);
    const minimumClass = Number(form.get("minimum_class"));
    const maximumClass = Number(form.get("maximum_class"));
    const classLevel = minimumClass === maximumClass ? minimumClass : null;

    const payload = {
      name: String(form.get("name") || "").trim(),
      price: Number(form.get("price")),
      duration_days: Number(form.get("duration_days")),
      practice_set_limit: Number(form.get("practice_set_limit")),
      main_exam_attempt_limit: Number(form.get("main_exam_attempt_limit")),
      class_level: classLevel,
      minimum_class: minimumClass,
      maximum_class: maximumClass,
      is_active: form.get("is_active") === "on",
    };

    if (!payload.name) {
      setError("Enter a plan name.");
      return;
    }

    if (
      !Number.isFinite(payload.price) ||
      payload.price < 0 ||
      !Number.isFinite(payload.duration_days) ||
      payload.duration_days < 1 ||
      !Number.isInteger(payload.practice_set_limit) ||
      payload.practice_set_limit < 0 ||
      !Number.isInteger(payload.main_exam_attempt_limit) ||
      payload.main_exam_attempt_limit < 0
    ) {
      setError("Check the price, duration, practice-set limit, and main-exam attempt limit.");
      return;
    }

    if (
      !CLASS_OPTIONS.includes(payload.minimum_class) ||
      !CLASS_OPTIONS.includes(payload.maximum_class) ||
      payload.minimum_class > payload.maximum_class
    ) {
      setError("Choose a valid class range from Class 5 through Class 12.");
      return;
    }

    setSaving(true);
    setError("");
    setMessage("");

    try {
      if (editing?.id) {
        await updateBeginnerSubscriptionPlan(editing.id, payload);
        setMessage("Subscription plan updated.");
      } else {
        await createBeginnerSubscriptionPlan(payload);
        setMessage("Subscription plan created.");
      }
      setEditing(null);
      formElement.reset();
      await loadPlans();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  const removePlan = async (plan) => {
    const action = plan.is_active ? "deactivate" : "delete";
    if (!window.confirm(`Are you sure you want to ${action} "${plan.name}"?`)) return;

    setSaving(true);
    setError("");
    setMessage("");

    try {
      await deleteBeginnerSubscriptionPlan(plan.id);
      setMessage(
        plan.is_active
          ? "Plan deactivated (it may be retained because it has payments/subscriptions)."
          : "Plan deleted or deactivated."
      );
      await loadPlans();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setSaving(false);
    }
  };

  const classSelect = (label, name, value) => (
    <label key={name}>
      {label}
      <select name={name} defaultValue={value ?? (name === "minimum_class" ? 5 : 5)} required>
        {CLASS_OPTIONS.map((classNumber) => (
          <option key={classNumber} value={classNumber}>
            Class {classNumber}
          </option>
        ))}
      </select>
    </label>
  );

  const setAllClasses = () => {
    const form = document.querySelector("form.beginner-admin-form");
    if (!form) return;
    form.elements.minimum_class.value = "5";
    form.elements.maximum_class.value = "12";
  };

  return (
    <div className="beginner-admin-columns">
      <section className="beginner-admin-panel">
        <h2>{editing ? "Edit subscription plan" : "Create subscription plan"}</h2>

        <form
          className="beginner-admin-form"
          onSubmit={savePlan}
          key={editing?.id || "new-plan"}
        >
          <label>
            Plan name
            <input
              name="name"
              required
              maxLength="120"
              defaultValue={editing?.name || ""}
              placeholder="e.g. Beginner Monthly"
            />
          </label>

          <div className="beginner-admin-form-grid">
            <label>
              Price (₹)
              <input
                name="price"
                type="number"
                min="0"
                step="0.01"
                required
                defaultValue={editing?.price ?? ""}
              />
            </label>

            <label>
              Duration (days)
              <input
                name="duration_days"
                type="number"
                min="1"
                max="3650"
                required
                defaultValue={editing?.duration_days ?? 30}
              />
            </label>

            <label>
              Practice-set limit
              <input
                name="practice_set_limit"
                type="number"
                min="0"
                max="100000"
                step="1"
                required
                defaultValue={editing?.practice_set_limit ?? 10}
              />
            </label>

            <label>
              Main-exam attempt limit
              <input
                name="main_exam_attempt_limit"
                type="number"
                min="0"
                max="100000"
                step="1"
                required
                defaultValue={editing?.main_exam_attempt_limit ?? 2}
              />
            </label>

            {classSelect(
              "Starting class",
              "minimum_class",
              editing?.minimum_class ?? editing?.class_level ?? 5
            )}
            {classSelect(
              "Ending class",
              "maximum_class",
              editing?.maximum_class ?? editing?.class_level ?? 5
            )}
          </div>

          <div className="beginner-admin-actions">
            <button type="button" className="secondary" onClick={setAllClasses}>
              All Classes (5–12)
            </button>
          </div>
          <p className="beginner-admin-note">
            Choose a starting and ending class. For example, 5–5 is only Class 5,
            5–7 includes Classes 5, 6, and 7, and 5–12 includes all classes.
            Use “All Classes” to set the range to Class 5–12.
          </p>

          <label className="beginner-admin-check">
            <input
              name="is_active"
              type="checkbox"
              defaultChecked={editing ? editing.is_active !== false : true}
            />
            Active and available to students
          </label>

          <div className="beginner-admin-actions">
            <button disabled={saving}>
              {saving ? "Saving…" : editing ? "Save changes" : "Create plan"}
            </button>
            {editing && (
              <button
                type="button"
                className="secondary"
                onClick={() => {
                  setEditing(null);
                  setError("");
                  setMessage("");
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      </section>

      <section className="beginner-admin-panel">
        <div className="beginner-admin-panel-title">
          <h2>Subscription plans ({plans.length})</h2>
          <button type="button" disabled={loading || saving} onClick={loadPlans}>
            Refresh
          </button>
        </div>

        {error && (
          <div className="beginner-admin-alert error" role="alert">
            {error}
          </div>
        )}

        {message && (
          <div className="beginner-admin-alert success" role="status">
            {message}
          </div>
        )}

        {loading ? (
          <p className="beginner-admin-loading">Loading subscription plans…</p>
        ) : plans.length === 0 ? (
          <p className="beginner-admin-empty">
            No subscription plans yet. Create your first plan using the form.
          </p>
        ) : (
          <div className="beginner-admin-table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Plan</th>
                  <th>Price</th>
                  <th>Duration</th>
                  <th>Practice limit</th>
                  <th>Main exam attempts</th>
                  <th>Eligible classes</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {plans.map((plan) => (
                  <tr key={plan.id}>
                    <td>{plan.name}</td>
                    <td>₹{Number(plan.price ?? 0).toFixed(2)}</td>
                    <td>{plan.duration_days} days</td>
                    <td>{plan.practice_set_limit ?? 10}</td>
                    <td>{plan.main_exam_attempt_limit ?? 2}</td>
                    <td>
                      {`Class ${plan.minimum_class ?? plan.class_level ?? 5}–${plan.maximum_class ?? plan.class_level ?? 12}`}
                    </td>
                    <td>
                      <span
                        className={`beginner-admin-status ${
                          plan.is_active ? "on" : "off"
                        }`}
                      >
                        {plan.is_active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td className="beginner-admin-row-actions">
                      <button
                        type="button"
                        disabled={saving}
                        onClick={() => {
                          setEditing(plan);
                          setError("");
                          setMessage("");
                        }}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="danger"
                        disabled={saving}
                        onClick={() => removePlan(plan)}
                      >
                        {plan.is_active ? "Deactivate / Delete" : "Delete"}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
